import React, { Fragment, useState, useContext, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Menu from '@material-ui/core/Menu';
import ListAltIcon from '@material-ui/icons/ListAlt';
import { GlobalContext } from '@mummssoftware/global-context/GlobalContext';
import { PNGlobalContext } from '@mummssoftware/global-context';
import { Context } from '../../context';
import StandingOrders from './StandingOrders';
import { StyledActionIcon } from '../../components';

const useStyles = makeStyles(() => ({
  menuPaper: {
    maxHeight: '86vh',
    width: 380,
    overflow: 'hidden',
  },
  menuList: {
    padding: '0px',
  },
}));

export const StandingOrdersMenu = () => {
  const { patientStandingOrdersGlobal } = useContext(GlobalContext);
  const { patientOrdersGlobal } = useContext(PNGlobalContext);
  const hasPSO =
    patientStandingOrdersGlobal && patientStandingOrdersGlobal.length;

  const [anchorEl, setAnchorEl] = useState(null);
  const classes = useStyles();

  const { patient } = useContext(Context);
  const onOpen = (e: any) => {
    setAnchorEl(e.currentTarget);
  };

  const onClose = () => {
    setAnchorEl(null);
  };

  return hasPSO ? (
    <Fragment>
      <StyledActionIcon
        Icon={ListAltIcon}
        onClick={onOpen}
        id="orders-ribbon"
      />
      <Menu
        id="pso-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={onClose}
        classes={{ list: classes.menuList }}
        PaperProps={{
          classes: {
            elevation8: classes.menuPaper,
          },
        }}
      >
        <div id="pso-sub-div">
          <StandingOrders
            patientStandingOrdersGlobal={patientStandingOrdersGlobal}
            patientOrdersGlobal={patientOrdersGlobal}
            patient={patient}
          />
        </div>
      </Menu>
    </Fragment>
  ) : (
    <></>
  );
};
export default StandingOrdersMenu;
